module.exports = __webpack_public_path__ + "36f34a9f4b3ef7fab7f54e3e7cc60184.svg";